import { memo, type FunctionComponent } from 'react';
// Material UI imports
import LinearProgress from '@mui/material/LinearProgress';

const EmptyScreen: FunctionComponent = () => <LinearProgress/>;

export default memo(EmptyScreen);
